export default __webpack_public_path__ + "static/media/selamat7.3b24f8dd.svg";